<app-spinner-overlay></app-spinner-overlay>

<app-compila-informativa-aziendale
  [infoAz]="data.infoAz"
  (completato)="finitaCompilazione($event)"
  *ngIf="data.infoAz"
  [inConf]="data.inConf"
></app-compila-informativa-aziendale>
